import { Image as ToolkitImage, type ImageProps, type ImageAsset } from '@etlyn/ui-toolkit/image';
import { useImageAsset } from '@etlyn/etlyn-cms';
import manifest from './image-manifest.json';

export const imageAsset = (src?: string) => src ? (manifest as Record<string, ImageAsset>)[src] : undefined;

export function Image(props: ImageProps) {
  const bundled = imageAsset(props.src);
  const asset = useImageAsset(props.src, props.asset || bundled);
  return <ToolkitImage {...props} asset={asset} />;
}
